export default function FounderPortrait() {
  return (
    <div className="col-span-12 md:col-span-5 lg:col-span-5">
      <div className="img-zoom overflow-hidden aspect-[4/5] relative">
        <img
          src="https://customer-assets.emergentagent.com/job_hii-connect-1131/artifacts/96lzk32k_IMG_5135.JPG"
          alt="Yashank Kalia, Founder & Managing Director"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-nightsky/30 to-transparent pointer-events-none" />
      </div>
      <div className="mt-6 text-[10px] tracking-widest3 uppercase text-goldleaf">
        Pushkar, Rajasthan · Photographed on assignment
      </div>
    </div>
  );
}
